import { IconButton, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledIconButton = styled(IconButton) `
  [data-icon='falcon'] {
    color: ${themeGet('colors.indigo.500')};
  }
`;
